/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Visit } from '../models/Visit';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VisitService {

    /**
     * Visit
     * @param key
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static visitApiV1VisitsPost(
        key: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/visits',
            query: {
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get
     * @param pageKey
     * @returns Visit Successful Response
     * @throws ApiError
     */
    public static getApiV1VisitsPageKeyGet(
        pageKey: string,
    ): CancelablePromise<Array<Visit>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/visits/{page_key}',
            path: {
                'page_key': pageKey,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
